<template>
  <div class="chat__header" :class="{ online, isMobile }">
    <span v-if="!isMobile" class="chat__header-title">{{$tCooperation('Chat')}}</span>
    <div class="chat__header-user">
      <div class="chat__header-user-details">
        <span class="chat__header-user-title">{{$tCooperation('Contact person')}}</span>
        <span class="chat__header-user-name">{{ username }}</span>
      </div>

      <div class="chat__header-user-avatar">
        <img :src="avatar" alt="">
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      username: String,
      avatar: String,
      online: Boolean,
      isMobile: Boolean
    }
  };
</script>
